// Mock data to define all the people who work on a special edition
export const credits = {
    "Corporate Board": [
            { staff_name: "Shea Vance", title: "Editor-in-Chief" },
            { staff_name: "Heather Chen", title: "Managing Editor" },
            { staff_name: "Albert Tsai", title: "Publisher" }
    ],
    "Engineering": [
      { "staff_name": "Noel Negron", "title": "Head of Engineering" },
      { "staff_name": "Aidan Lee", "title": "Engineering Manager" }
    ],
    "Product": [
      { "staff_name": "Daniela Velazquez", "title": "Head of Product" },
      { "staff_name": "Melinda Yao", "title": "Product Deputy" }
    ],
    "University News": [
      {
        "staff_name": "Isha Banerjee",
        "title": "University News Editor"
      },{
        "staff_name": "Daniela Ospino Pallares",
        "title": "Senior Staff Writer"
      },
      {
        "staff_name": "Tulasi Cherukuri",
        "title": "Staff Writer"
      },
      {
        "staff_name": "Wiann Wilson",
        "title": "Staff Writer"
      },
      {
        "staff_name": "Ria Vasishtha",
        "title": "Staff Writer"
      },
    ],
    "City News": [
      { "staff_name": "Tsehai Alfred", "title": "City News Editor" },
      { "staff_name": "Aiyana St.Hilaire", "title": "City News Deputy Editor" },
      { "staff_name": "Thomas Stewart", "title": "Senior Staff Writer" },
    ],
    "Arts and Culture": [
      { "staff_name": "Joyce Zhang", "title": "Arts & Culture Editor" },
      { "staff_name": "Rachel Shaw", "title": "Deputy Arts & Culture Editor" },
      { "staff_name": "Emily Chen", "title": "Senior Staff Writer" },
      { "staff_name": "Ariana Eftimiu", "title": "Senior Staff Writer" },
      { "staff_name": "Madison Rosenfield", "title": "Senior Staff Writer" },
      { "staff_name": "Taylor Graham", "title": "Staff Writer" }
    ],
    "Sports": [
      { "staff_name": "Jillian Prunty", "title": "Sports Editor" },
      { "staff_name": "Arielle Rieder", "title": "Sports Editor" },
      { "staff_name": "Ashley Flores", "title": "Deputy Sports Editor" },
      { "staff_name": "Kaya Quebada", "title": "Staff Writer" },
      { "staff_name": "Andrew Vincenti", "title": "Staff Writer" }
    ],
    "Video": [
      { "staff_name": "Elliot Heath", "title": "Video Editor" },
      { "staff_name": "Emily Huang", "title": "Deputy Video Editor" },
      { "staff_name": "Jordan Pettiford", "title": "Video Associate" },
      { "staff_name": "Hanan Ali", "title": "Video Associate" },
      { "staff_name": "Ashlynne Graham", "title": "Video Associate" },
      { "staff_name": "Tasneem Meem", "title": "Video Associate" }
    ],
    "Photo": [
      { "staff_name": "Gaby Diaz-Vendrell", "title": "Deputy Photo Editor" },
      { "staff_name": "Asha Ahn", "title": "Deputy Photo Editor" },
      { "staff_name": "Anna Fedorova", "title": "Deputy Photo Editor" }
    ],
    "Spectrum": [
      { "staff_name": "Manuela Moreyra", "title": "Spectrum Editor" },
      { "staff_name": "Ria Dalal", "title": "Spectrum Deputy Editor" },
      { "staff_name": "Loyca Jean", "title": "Spectrum Deputy Editor" },
      { "staff_name": "Jasveenkaur Wahan", "title": "Spectrum Deputy Editor" },
      { "staff_name": "Mulki Ahmed", "title": "Staff Writer" }
    ],
    "Illustrations": [
      { "staff_name": "Conner Sund", "title": "Illustrations Editor" },
      { "staff_name": "Saumya Chaudhry", "title": "Deputy Illustrations Editor" },
      { "staff_name": "Anaïs Fotsing", "title": "Deputy Illustrations Editor" },
      { "staff_name": "Shanying Liu", "title": "Staff Illustrator" }
    ],
    "Graphics": [
      { "staff_name": "Jenny Ye", "title": "Graphics Editor" },
      { "staff_name": "Wilson Zhen", "title": "Graphics Deputy Editor" },
      { "staff_name": "Alison Chiu", "title": "Graphics Associate" }
    ],
    "Crosswords": [
      { "staff_name": "Ananya Govindarajan", "title": "Head of Crosswords" },
      { "staff_name": "Molly Durawa", "title": "Crosswords Deputy Editor" },
      { "staff_name": "Reda Shaikh", "title": "Crosswords Deputy Editor" }
    ],
    "Copy": [
      { "staff_name": "Posey Chiddix", "title": "Head Copy Editor" },
      { "staff_name": "Eli Trokenheim", "title": "Deputy Copy Editor" },
      { "staff_name": "Emily Spencer", "title": "Deputy Copy Editor" },
      { "staff_name": "Diego Carvajal Núñez", "title": "Deputy Copy Editor" },
      { "staff_name": "Reese Ransweiler", "title": "Deputy Copy Editor" },
      { "staff_name": "Vaishu Sirkay", "title": "Deputy Copy Editor" },
      { "staff_name": "Campbell Beaver", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Claudia Kim", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Daniel Knorek", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Elizabeth Kushelevsky", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Eric Aguilar", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Georgia Bryan", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Katharine Lee", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Lily Lee", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Megha Parikh", "title": "Senior Associate Copy Editor" },
      { "staff_name": "Althea Downing-Sherer", "title": "Associate Copy Editor" },
      { "staff_name": "Ames Yu", "title": "Associate Copy Editor" },
      { "staff_name": "Gigi Chen", "title": "Associate Copy Editor" },
      { "staff_name": "Natalie Wise", "title": "Associate Copy Editor" },
      { "staff_name": "Yoona Lee", "title": "Associate Copy Editor" }
    ]
};